var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccessIcon = function SvgSuccessIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#23A971",
    d: "M1.707 6.293A1 1 0 0 0 .293 7.707zM7 13l-.707.707a1 1 0 0 0 1.414 0zM19.707 1.707A1 1 0 0 0 18.293.293zm-19.414 6 6 6 1.414-1.414-6-6zm7.414 6 12-12L18.293.293l-12 12z"
  })));
};
export default SvgSuccessIcon;